(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-announcement-ticker"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('mercadean-ticker'))customElements.define('mercadean-ticker',class extends HTMLElement{
 connectedCallback(){
  this.abort?.abort();this.abort=new AbortController();const o={signal:this.abort.signal};
  this.track=this.querySelector('.mt__track');this.original=this.querySelector('[data-original]');this.viewport=this.querySelector('.mt__viewport');this.motion=matchMedia('(prefers-reduced-motion:reduce)');
  if(!this.original||!this.track)return;
  this.motion.addEventListener('change',()=>{this.sizeKey='';this.rebuild();},o);
  document.addEventListener('visibilitychange',()=>this.sync(),o);window.addEventListener('pageshow',()=>this.sync(),o);
  this.observer=new ResizeObserver(()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>this.rebuild());});
  this.observer.observe(this.original);this.observer.observe(this.viewport);this.rebuild();
  document.fonts.ready.then(()=>{if(this.isConnected)this.rebuild();});
 }
 sync(){if(!this.animation)return;if(document.hidden||this.motion.matches)this.animation.pause();else this.animation.play();}
 rebuild(){
  const distance=this.original.getBoundingClientRect().width, width=this.viewport.clientWidth;
  const key=[distance,width,this.motion.matches].join(':');if(key===this.sizeKey)return;this.sizeKey=key;
  const progress=this.duration?(Number(this.animation?.currentTime)||0)%this.duration/this.duration:0;
  this.animation?.cancel();this.track.querySelectorAll('[data-clone]').forEach(n=>n.remove());
  if(this.motion.matches||distance<=1)return;
  for(let i=0;i<Math.ceil(width/distance)+1;i++){const clone=this.original.cloneNode(true);clone.removeAttribute('data-original');clone.setAttribute('data-clone','');clone.setAttribute('aria-hidden','true');clone.inert=true;clone.querySelectorAll('[data-shopify-editor-block]').forEach(n=>n.removeAttribute('data-shopify-editor-block'));this.track.append(clone);}
  this.duration=distance/Math.max(1,Number(this.dataset.speed)||50)*1000;
  this.animation=this.track.animate([{transform:'translateX(0)'},{transform:'translateX(-'+distance+'px)'}],{duration:this.duration,iterations:Infinity,easing:'linear'});
  this.animation.currentTime=progress*this.duration;this.sync();
 }
 disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.animation?.cancel();cancelAnimationFrame(this.frame);}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-footer"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('mercadean-footer'))customElements.define('mercadean-footer',class extends HTMLElement{
 connectedCallback(){
  this.abort?.abort();this.abort=new AbortController();const o={signal:this.abort.signal};
  this.track=this.querySelector('.mf__track');this.original=this.querySelector('[data-original]');this.viewport=this.querySelector('.mf__viewport');this.motion=matchMedia('(prefers-reduced-motion:reduce)');
  if(!this.original||!this.track)return;
  this.motion.addEventListener('change',()=>{this.sizeKey='';this.rebuild();},o);
  document.addEventListener('visibilitychange',()=>this.sync(),o);window.addEventListener('pageshow',()=>this.sync(),o);
  this.observer=new ResizeObserver(()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>this.rebuild());});
  this.observer.observe(this.original);this.observer.observe(this.viewport);this.rebuild();
  document.fonts.ready.then(()=>{if(this.isConnected)this.rebuild();});
 }
 sync(){if(!this.animation)return;if(document.hidden||this.motion.matches)this.animation.pause();else this.animation.play();}
 rebuild(){
  const distance=this.original.getBoundingClientRect().width, width=this.viewport.clientWidth;
  const key=[distance,width,this.motion.matches].join(':');if(key===this.sizeKey)return;this.sizeKey=key;
  const progress=this.duration?(Number(this.animation?.currentTime)||0)%this.duration/this.duration:0;
  this.animation?.cancel();this.track.querySelectorAll('[data-clone]').forEach(n=>n.remove());
  if(this.motion.matches||distance<=1)return;
  for(let i=0;i<Math.ceil(width/distance)+1;i++){const clone=this.original.cloneNode(true);clone.removeAttribute('data-original');clone.setAttribute('data-clone','');clone.setAttribute('aria-hidden','true');clone.inert=true;clone.querySelectorAll('[data-shopify-editor-block]').forEach(n=>n.removeAttribute('data-shopify-editor-block'));this.track.append(clone);}
  this.duration=distance/Math.max(1,Number(this.dataset.speed)||50)*1000;
  this.animation=this.track.animate([{transform:'translateX(0)'},{transform:'translateX(-'+distance+'px)'}],{duration:this.duration,iterations:Infinity,easing:'linear'});
  this.animation.currentTime=progress*this.duration;this.sync();
 }
 disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.animation?.cancel();cancelAnimationFrame(this.frame);}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-instagram-showcase"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mercadean-instagram')) {
  customElements.define('mercadean-instagram', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const track = this.querySelector('.mig__grid');
      const slides = [...this.querySelectorAll('.mig__cell')];
      const controls = this.querySelector('.mig__controls');
      const dots = [...this.querySelectorAll('.mig__dot')];
      const previous = this.querySelector('[data-direction="-1"]');
      const next = this.querySelector('[data-direction="1"]');
      const status = this.querySelector('.mig__status');
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const mobile = window.matchMedia('(max-width: 599px)');
      let active = 0;
      let intended = null;
      const distanceTo = index => {
        const box = slides[index].getBoundingClientRect();
        const viewport = track.getBoundingClientRect();
        return box.left + box.width / 2 - viewport.left - track.clientWidth / 2;
      };
      const update = () => {
        if (!slides.length) return;
        active = slides.reduce((best, slide, index) => Math.abs(distanceTo(index)) < Math.abs(distanceTo(best)) ? index : best, 0);
        dots.forEach((dot, index) => { if (index === active) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
        previous?.setAttribute('aria-disabled', String(active === 0));
        next?.setAttribute('aria-disabled', String(active === slides.length - 1));
        if (intended === active && Math.abs(distanceTo(active)) < 2) intended = null;
      };
      const announce = () => {
        update();
        if (status) status.textContent = `${status.dataset.statusLabel} ${active + 1} / ${slides.length}`;
        intended = null;
      };
      const goTo = (index, behavior = motion.matches ? 'auto' : 'smooth') => {
        const target = Math.max(0, Math.min(index, slides.length - 1));
        if (!slides.length) return;
        intended = target;
        this.cancelMotion?.();
        const left=track.scrollLeft+distanceTo(target);
        if(window.MercadeanMotion)this.cancelMotion=window.MercadeanMotion.scroll(track,left,behavior!=='auto',announce);
        else {track.scrollBy({left:distanceTo(target),behavior});if(behavior==='auto')announce();}
      };
      if (controls) controls.hidden = false;
      track.tabIndex = slides.length > 1 ? 0 : -1;
      slides.forEach(slide => slide.removeAttribute('data-reveal'));
      this.querySelectorAll('[data-direction]').forEach(arrow => arrow.addEventListener('click', () => {
        goTo((intended ?? active) + Number(arrow.dataset.direction));
      }, options));
      dots.forEach((dot, index) => dot.addEventListener('click', () => goTo(index), options));
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(update);
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(announce, 180);
      }, { ...options, passive: true });
      track.addEventListener('scrollend', announce, options);
      track.addEventListener('pointerdown', () => { intended = null; }, options);
      track.addEventListener('wheel', () => { intended = null; }, { ...options, passive: true });
      track.addEventListener('keydown', event => {
        if (event.target !== track) return;
        let target;
        if (event.key === 'ArrowRight') target = (intended ?? active) + 1;
        if (event.key === 'ArrowLeft') target = (intended ?? active) - 1;
        if (event.key === 'Home') target = 0;
        if (event.key === 'End') target = slides.length - 1;
        if (target === undefined) return;
        event.preventDefault();
        goTo(target);
      }, options);
      const resize = () => {
        cancelAnimationFrame(this.resizeFrame);
        this.resizeFrame = requestAnimationFrame(() => goTo(active, 'auto'));
      };
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(resize);
        this.resizeObserver.observe(track);
      } else window.addEventListener('resize', resize, options);
      mobile.addEventListener('change', resize, options);
      motion.addEventListener('change', () => goTo(intended ?? active, 'auto'), options);
      if (window.Shopify?.designMode) document.addEventListener('shopify:block:select', event => {
        const index = slides.findIndex(slide => slide === event.target || slide.contains(event.target));
        if (index !== -1) goTo(index, 'auto');
      }, options);
      update();
    }
    disconnectedCallback() {
      this.cancelMotion?.();
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.resizeFrame);
      clearTimeout(this.settleTimer);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-showcase-grid"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mercadean-showcase')) {
  customElements.define('mercadean-showcase', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const hover = window.matchMedia('(hover: hover) and (pointer: fine)');
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const carousel = window.matchMedia('(max-width: 989px)');
      const perPage = () => window.matchMedia('(max-width:749px)').matches ? 2 : 3;
      const cards = this.querySelectorAll('.msg__card');
      const rows = this.querySelectorAll('.msg__row');
      const revealAll = () => {
        this.observer?.disconnect();
        cards.forEach(card => card.removeAttribute('data-reveal'));
      };
      const syncRows = () => rows.forEach(row => {
        row.tabIndex = carousel.matches ? 0 : -1;
        const controls = row.nextElementSibling;
        controls.hidden = !carousel.matches || row.children.length <= perPage();
        const page = Math.round(row.scrollLeft / (row.clientWidth || 1));
        const total = Math.ceil(row.children.length / perPage());
        controls.querySelector('.msg__page-status').textContent = (page + 1) + ' / ' + total;
        controls.querySelector('[data-page-step="-1"]').disabled = page === 0;
        controls.querySelector('[data-page-step="1"]').disabled = page >= total - 1;
        [...row.children].forEach((cell,i) => {cell.inert = carousel.matches && Math.floor(i/perPage()) !== page;});
      });
      rows.forEach(row => {
        row.dataset.page = '0';
        row.nextElementSibling.querySelectorAll('[data-page-step]').forEach(button => button.addEventListener('click', () => {
          const page = Math.max(0,Math.min(Math.ceil(row.children.length/perPage())-1,Number(row.dataset.page)+Number(button.dataset.pageStep)));
          row.dataset.page = String(page);
          if(window.MercadeanMotion)window.MercadeanMotion.scroll(row,page*row.clientWidth,!motion.matches);
          else row.scrollTo({left:page*row.clientWidth,behavior:motion.matches?'auto':'smooth'});
        },options));
        row.addEventListener('scroll',()=>{syncRows();}, {...options,passive:true});
        row.addEventListener('scrollend',()=>{row.dataset.page=String(Math.round(row.scrollLeft/(row.clientWidth||1)));},options);
        this.rowResize ??= new ResizeObserver(()=>{rows.forEach(r=>{r.scrollTo({left:0,behavior:'instant'});r.dataset.page='0';});syncRows();});
        this.rowResize.observe(row);
      });
      revealAll();
      syncRows();
      this.querySelectorAll('.msg__media--pair').forEach(media => {
        const primary=media.querySelector('.msg__image--primary'),secondary=media.querySelector('.msg__image--secondary');
        const card=media.closest('.msg__card');
        const show=active=>{media.classList.toggle('is-secondary',active);primary.setAttribute('aria-hidden',String(active));secondary.setAttribute('aria-hidden',String(!active));};
        card.addEventListener('pointerenter',e=>{if(hover.matches&&e.pointerType==='mouse')show(true);},options);
        card.addEventListener('pointerleave',e=>{if(e.pointerType==='mouse'&&!card.contains(document.activeElement))show(false);},options);
        card.addEventListener('focusin',()=>show(true),options);
        card.addEventListener('focusout',e=>{if(!card.contains(e.relatedTarget))show(false);},options);
        media.addEventListener('pointerdown',()=>show(true),{...options,passive:true});
        media.addEventListener('pointercancel',()=>show(false),options);
        show(false);
      });

      carousel.addEventListener('change', () => { revealAll(); syncRows(); }, options);
      motion.addEventListener('change', revealAll, options);
      rows.forEach(row => row.addEventListener('keydown', event => {
        if (!carousel.matches || event.target !== row) return;
        const step = row.clientWidth;
        let left;
        if (event.key === 'ArrowRight') left = step;
        if (event.key === 'ArrowLeft') left = -step;
        if (event.key === 'Home') left = -row.scrollLeft;
        if (event.key === 'End') left = row.scrollWidth - row.clientWidth - row.scrollLeft;
        if (left === undefined) return;
        event.preventDefault();
        row.scrollBy({ left, behavior: motion.matches ? 'auto' : 'smooth' });
      }, options));
      this.addEventListener('focusin', event => {
        const card = event.target.closest('.msg__card');
        if (card) { card.removeAttribute('data-reveal'); this.observer?.unobserve(card); }
      }, options);
      if (window.Shopify?.designMode) {
        document.addEventListener('shopify:block:select', event => {
          if (!this.contains(event.target)) return;
          const cell = event.target.closest('.msg__cell');
          const row = cell?.closest('.msg__row');
          if (cell && row && carousel.matches) row.scrollBy({ left: cell.getBoundingClientRect().left - row.getBoundingClientRect().left, behavior: 'auto' });
        }, options);
      }
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); this.rowResize?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('mercadean-home-header-height')) {
    customElements.define('mercadean-home-header-height', class extends HTMLElement {
      connectedCallback() {
        const header = this.closest('.section-header');
        if (!header || !header.querySelector('[data-mercadean-home-overlay]')) return;
        this.observer = new ResizeObserver(() => {
          header.style.setProperty('--mercadean-header-height', header.offsetHeight + 'px');document.documentElement.style.setProperty('--header-height',header.offsetHeight+'px');
        });
        this.observer.observe(header);
        header.style.setProperty('--mercadean-header-height', header.offsetHeight + 'px');
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mercadean-collection"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mercadean-products')) {
  customElements.define('mercadean-products', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const hover = window.matchMedia('(hover: hover) and (pointer: fine)');
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const cards = this.querySelectorAll('.mpc__card');
      cards.forEach(card => card.removeAttribute('data-reveal'));
      this.querySelectorAll('.mpc__media--pair').forEach(media => {
        const toggle = media.querySelector('.mpc__image-toggle');
        const primary = media.querySelector('.mpc__image--primary');
        const secondary = media.querySelector('.mpc__image--secondary');
        const show = active => {
          media.classList.toggle('is-secondary', active);
          toggle.setAttribute('aria-pressed', String(active));
          primary.setAttribute('aria-hidden', String(active));
          secondary.setAttribute('aria-hidden', String(!active));
        };
        const flip = () => show(!media.classList.contains('is-secondary'));
        show(false);
        toggle.disabled = false;
        toggle.addEventListener('click', flip, options);
        media.addEventListener('pointerenter', event => {
          if (hover.matches && event.pointerType === 'mouse') show(true);
        }, options);
        media.addEventListener('pointerleave', event => {
          if (hover.matches && event.pointerType === 'mouse') show(false);
        }, options);
      });
      if ('IntersectionObserver' in window && !motion.matches && !window.Shopify?.designMode) {
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.setAttribute('data-reveal', 'visible');
              this.observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.08 });
        cards.forEach(card => {
          card.setAttribute('data-reveal', 'waiting');
          this.observer.observe(card);
        });
      }
      motion.addEventListener('change', event => {
        if (event.matches) {
          this.observer?.disconnect();
          cards.forEach(card => card.removeAttribute('data-reveal'));
        }
      }, options);
      if (window.Shopify?.designMode) {
        document.addEventListener('shopify:block:select', event => {
          if (this.contains(event.target)) {
            event.target.closest('.mpc__cell')?.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'instant' });
          }
        }, options);
      }
      this.addEventListener('focusin', event => {
        const card = event.target.closest('.mpc__card');
        if (card) {
          card.removeAttribute('data-reveal');
          this.observer?.unobserve(card);
        }
      }, options);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mercadean-hero-slides"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mercadean-hero')) customElements.define('mercadean-hero', class extends HTMLElement {
 connectedCallback() {
  this.controller?.abort();this.visibilityObserver?.disconnect();clearTimeout(this.timer);
  this.controller=new AbortController();const o={signal:this.controller.signal};
  const track=this.querySelector('.mh__track'),slides=[...this.querySelectorAll('.mh__slide')],dots=[...this.querySelectorAll('.mh__indicator')];
  const controls=this.querySelector('.mh__controls'),pause=this.querySelector('.mh__pause'),status=this.querySelector('.mh__status');
  const motion=matchMedia('(prefers-reduced-motion:reduce)');
  let active=0,hovering=false,focusing=false,touching=false,visible=true,paused=motion.matches||Boolean(window.Shopify?.designMode);
  const stop=()=>clearTimeout(this.timer);
  const schedule=()=>{stop();if(slides.length>1&&this.dataset.autoplay==='true'&&!paused&&!hovering&&!focusing&&!touching&&visible&&!document.hidden)this.timer=setTimeout(()=>goTo(active+1,false),Number(this.dataset.interval)||4000);};
  const syncPause=()=>{if(!pause)return;pause.setAttribute('aria-label',paused?pause.dataset.playLabel:pause.dataset.pauseLabel);pause.querySelector('span').textContent=paused?'▷':'Ⅱ';};
  // Commit the selected index immediately: rapid clicks never race an animation callback.
  const goTo=(index,user=true)=>{
   if(!slides.length)return;stop();active=((index%slides.length)+slides.length)%slides.length;
   slides.forEach((slide,i)=>{slide.classList.toggle('is-active',i===active);slide.inert=i!==active;slide.setAttribute('aria-hidden',String(i!==active));});
   dots.forEach((dot,i)=>i===active?dot.setAttribute('aria-current','true'):dot.removeAttribute('aria-current'));
   if(user&&status)status.textContent=status.dataset.label+' '+(active+1)+' / '+slides.length;
   schedule();
  };
  if(controls)controls.hidden=false;
  dots.forEach((dot,i)=>dot.addEventListener('click',()=>goTo(i),o));
  this.querySelectorAll('[data-direction]').forEach(button=>button.addEventListener('click',()=>goTo(active+Number(button.dataset.direction)),o));
  pause?.addEventListener('click',()=>{paused=!paused;syncPause();schedule();},o);
  this.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'){hovering=true;stop();}},o);
  this.addEventListener('pointerleave',e=>{if(e.pointerType==='mouse'){hovering=false;schedule();}},o);
  this.addEventListener('focusin',()=>{focusing=true;stop();},o);
  this.addEventListener('focusout',e=>{focusing=this.contains(e.relatedTarget);schedule();},o);
  this.addEventListener('pointerdown',()=>{touching=true;stop();},o);
  const release=()=>{touching=false;schedule();};window.addEventListener('pointerup',release,o);window.addEventListener('pointercancel',release,o);
  track.addEventListener('keydown',e=>{if(e.target!==track)return;const i={ArrowRight:active+1,ArrowLeft:active-1,Home:0,End:slides.length-1}[e.key];if(i===undefined)return;e.preventDefault();goTo(i);},o);
  document.addEventListener('visibilitychange',schedule,o);window.addEventListener('pageshow',schedule,o);
  motion.addEventListener('change',()=>{paused=motion.matches;syncPause();schedule();},o);
  this.visibilityObserver=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;this.classList.toggle('is-in-view',visible);schedule();},{threshold:.1});this.visibilityObserver.observe(this);
  document.addEventListener('shopify:block:select',e=>{const i=slides.findIndex(slide=>slide.dataset.blockId===e.detail.blockId);if(i<0)return;paused=true;syncPause();goTo(i);},o);
  let heroTop=0,heroHeight=0;
  const measure=()=>{
   const rect=this.getBoundingClientRect();heroTop=rect.top+window.scrollY;heroHeight=rect.height;
   const cue=this.querySelector('.mh__scroll-cue');
   if(cue){const cueHeight=cue.offsetHeight||190;const viewport=window.visualViewport?.height||innerHeight;const bottom=Math.min(heroHeight-20,viewport-heroTop-24);this.style.setProperty('--mh-cue-top',Math.max(100,bottom-cueHeight)+'px');}
  };
  this.parallaxResize=new ResizeObserver(measure);this.parallaxResize.observe(this);
  const header=document.querySelector('.section-header');if(header)this.parallaxResize.observe(header);
  window.addEventListener('resize',measure,o);
  window.addEventListener('pageshow',measure,o);
  measure();
  goTo(0,false);syncPause();
 }
 disconnectedCallback(){this.parallaxResize?.disconnect();this.controller?.abort();this.visibilityObserver?.disconnect();clearTimeout(this.timer);}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mercadean-product-gallery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mercadean-product-gallery')) {
  customElements.define('mercadean-product-gallery', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.resize?.disconnect();
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      const track = this.querySelector('.mpg__track');
      const slides = [...this.querySelectorAll('.mpg__slide')];
      const previous = this.querySelector('[data-step="-1"]');
      const next = this.querySelector('[data-step="1"]');
      const counter = this.querySelector('.mpg__counter');
      const status = this.querySelector('.mpg__status');
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      let active = 0;
      let intended = null;
      let transition = 0;
      let width = track.clientWidth;
      const prepare = index => {
        const image = slides[index]?.querySelector('img');
        if (!image) return;
        image.loading = 'eager';
        return image;
      };
      slides.forEach((_, index) => prepare(index));
      const update = () => {
        active = Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/(track.clientWidth || 1))));
        if (previous) previous.disabled = active === 0;
        if (next) next.disabled = active === slides.length-1;
        if (counter) counter.textContent = (active+1)+' / '+slides.length;
      };
      const stop = () => {
        cancelAnimationFrame(this.animation);
        track.style.scrollSnapType = '';
        intended = null;
      };
      const announce = () => {
        update();
        if (status) status.textContent = track.getAttribute('aria-label')+': '+(active+1)+' / '+slides.length;
      };
      const go = async index => {
        const target = Math.max(0,Math.min(slides.length-1,index));
        stop();
        clearTimeout(this.settle);
        intended = target;
        const start = track.scrollLeft;
        const end = target*track.clientWidth;
        const duration = motion.matches ? 0 : Number(this.dataset.duration);
        track.style.scrollSnapType = 'none';
        if (!duration) {
          track.scrollLeft = end;
          stop();
          announce();
          return;
        }
        const started = performance.now();
        const tick = now => {
          const p = Math.min(1,(now-started)/duration);
          const eased = p < .5 ? 4*p*p*p : 1-Math.pow(-2*p+2,3)/2;
          track.scrollLeft = start+(end-start)*eased;
          if (p<1) this.animation = requestAnimationFrame(tick);
          else { stop(); announce(); }
        };
        this.animation = requestAnimationFrame(tick);
      };
      this.querySelector('.mpg__controls')?.removeAttribute('hidden');
      this.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click',()=>go((intended ?? active)+Number(button.dataset.step)),options));
      track.addEventListener('scroll',()=>{
        update();
        clearTimeout(this.settle);
        this.settle = setTimeout(announce,180);
      },{...options,passive:true});
      track.addEventListener('pointerdown',stop,{...options,passive:true});
      track.addEventListener('wheel',stop,{...options,passive:true});
      track.addEventListener('keydown',event=>{
        if (event.target !== track) return;
        const keys = {ArrowLeft:(intended ?? active)-1,ArrowRight:(intended ?? active)+1,Home:0,End:slides.length-1};
        if (event.key in keys) {event.preventDefault();go(keys[event.key]);}
      },options);
      motion.addEventListener('change',()=>go(active),options);
      this.resize = new ResizeObserver(()=>{
        stop();
        track.style.scrollSnapType = 'none';
        track.scrollLeft = active*track.clientWidth;
        track.style.scrollSnapType = '';
        update();
      });
      this.resize.observe(track);
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resize?.disconnect();
      cancelAnimationFrame(this.animation);
      clearTimeout(this.settle);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mercadean-product-ingredients"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('melaxin-ingredients')) customElements.define('melaxin-ingredients', class extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.addEventListener('toggle', event => {
      if (!(event.target instanceof HTMLDetailsElement) || !event.target.open) return;
      this.querySelectorAll('details[open]').forEach(detail => {
        if (detail !== event.target) detail.open = false;
      });
    }, { capture: true, signal: this.controller.signal });
  }
  disconnectedCallback() { this.controller?.abort(); }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mercadean-product-offers"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('mercadean-offers'))customElements.define('mercadean-offers',class extends HTMLElement{
 connectedCallback(){
  this.controller?.abort();this.controller=new AbortController();const opts={signal:this.controller.signal},cards=[...this.querySelectorAll('.mpo__card')],status=this.querySelector('.mpo__selection');
  const select=(card,focus=false,syncNative=true)=>{cards.forEach(c=>{const active=c===card;c.setAttribute('aria-checked',String(active));c.tabIndex=active?0:-1});if(focus)card.focus();this.selectedOffer={blockId:card.dataset.offer,variantId:card.dataset.variant,quantity:Number(card.dataset.quantity),price:card.dataset.price};if(status)status.textContent=this.dataset.label+' '+card.dataset.name+' · '+card.dataset.quantity+' '+this.dataset.unit+' · '+card.dataset.price;this.dispatchEvent(new CustomEvent('mercadean:offer-change',{bubbles:true,detail:this.selectedOffer}));if((this.dataset.terraOffers==='true'||this.dataset.oftalmielOffers==='true')&&syncNative&&this.dataset.codSync==='true'){pending=card;queue()}};
  cards.forEach((card,i)=>{card.addEventListener('click',()=>select(card),opts);card.addEventListener('keydown',e=>{let next=i;if(e.key==='ArrowRight'||e.key==='ArrowDown')next=(i+1)%cards.length;else if(e.key==='ArrowLeft'||e.key==='ArrowUp')next=(i-1+cards.length)%cards.length;else if(e.key==='Home')next=0;else if(e.key==='End')next=cards.length-1;else return;e.preventDefault();select(cards[next],true)},opts)});

  const norm=s=>String(s||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim().toLowerCase(),amount=s=>String(s||'').replace(/[^0-9]/g,'');
  let pending=null,frame=0;
  const nativeCards=()=>{const modal=document.querySelector('#_rsi-cod-form-modal');return modal&&modal.getClientRects().length?[...modal.querySelectorAll('._rsi-quantity-offers-offer-container')]:[]};
  const matches=(outer,native)=>norm(native.querySelector('._rsi-quantity-offers-title')?.textContent)===norm(outer.dataset.name)&&amount(native.querySelector('._rsi-quantity-offers-new-price')?.textContent)===amount(outer.dataset.price);
  const reconcile=()=>{frame=0;const native=nativeCards();if(!native.length)return;
  if(this.dataset.terraOffers==='true'){
   const complete=cards.length===3&&cards.every(c=>native.some(n=>matches(c,n)));
   if(complete){const modal=document.getElementById('_rsi-cod-form-modal');if(!modal.classList.contains('ms-terra-offers'))modal.classList.add('ms-terra-offers');
    native.forEach(n=>{const outer=cards.find(c=>matches(c,n));if(!outer)return;const source=outer.querySelector('img')?.currentSrc||outer.querySelector('img')?.src;const body=n.querySelector('._rsi-quantity-offers-offer');if(!source||!body)return;let image=body.querySelector('img');if(!image){image=document.createElement('img');image.alt='';body.prepend(image)}if(image.src!==source)image.src=source;if(!image.classList.contains('ms-terra-offer-image'))image.classList.add('ms-terra-offer-image');image.loading='lazy';});
   }
  }
  if(pending){const target=native.find(n=>matches(pending,n));if(!target)return;if(!target.classList.contains('_rsi-quantity-offers-selected'))target.querySelector('._rsi-quantity-offers-offer')?.click();return;}const current=native.find(n=>n.classList.contains('_rsi-quantity-offers-selected'));const outer=current&&cards.find(c=>matches(c,current));if(outer&&outer.getAttribute('aria-checked')!=='true')select(outer,false,false);};
  const queue=()=>{if(!frame)frame=requestAnimationFrame(reconcile)};
  if(this.dataset.codSync==='true'){document.addEventListener('click',e=>{if(e.isTrusted&&e.target.closest('._rsi-quantity-offers-offer-container')){pending=null;queue()}if(e.target.closest('._rsi-buy-now-button')){pending=cards.find(c=>c.getAttribute('aria-checked')==='true')||null;queue()}}, {...opts,capture:true});this.nativeObserver=new MutationObserver(queue);this.nativeObserver.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['class','style']});}
  this.stopSync=()=>{this.nativeObserver?.disconnect();cancelAnimationFrame(frame)};
  if(cards.length)select(cards[Math.min(cards.length-1,Math.max(0,Number(this.dataset.default)-1))]);
 }
 disconnectedCallback(){this.controller?.abort();this.stopSync?.()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mercadean-product-reviews"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('mercadean-reviews'))customElements.define('mercadean-reviews',class extends HTMLElement{
 connectedCallback(){
  this.controller?.abort();this.resize?.disconnect();this.observer?.disconnect();clearInterval(this.timer);
  this.controller=new AbortController();const opts={signal:this.controller.signal},track=this.querySelector('.mpr__track'),cards=[...this.querySelectorAll('.mpr__card')],dots=this.querySelector('.mpr__dots'),prev=this.querySelector('[data-prev]'),next=this.querySelector('[data-next]'),controls=this.querySelector('.mpr__controls'),motion=matchMedia('(prefers-reduced-motion: reduce)');
  let columns=1,count=1,active=0,paused=false,inView=false;
  const terra=this.dataset.terraReviews==='true',hover=matchMedia('(hover: hover) and (pointer: fine)');
  const focusBlocks=()=>this.contains(document.activeElement)&&(!terra||document.activeElement.matches(':focus-visible'));
  const update=()=>{active=Math.min(count-1,Math.round(track.scrollLeft/(track.clientWidth+parseFloat(getComputedStyle(track).gap))));if(prev)prev.disabled=active===0;if(next)next.disabled=active>=count-1;dots?.querySelectorAll('button').forEach((d,i)=>d.setAttribute('aria-current',String(i===active)))};
  const go=index=>{const n=Math.max(0,Math.min(count-1,index)),card=cards[n*columns];if(!card)return;this.cancelMotion?.();this.motionTarget=n;const left=card.offsetLeft-cards[0].offsetLeft;if(window.MercadeanMotion)this.cancelMotion=window.MercadeanMotion.scroll(track,left,this.dataset.smooth==='true',()=>{this.motionTarget=null;update()});else{track.scrollTo({left,behavior:this.dataset.smooth==='true'&&!motion.matches?'smooth':'instant'});this.motionTarget=null}};
  const resize=()=>{this.cancelMotion?.();if(!cards.length){controls.hidden=true;return}columns=Math.max(1,Math.round((track.clientWidth+parseFloat(getComputedStyle(track).gap))/(cards[0].getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap))));count=Math.ceil(cards.length/columns);if(dots){dots.replaceChildren();for(let i=0;i<count;i++){const dot=document.createElement('button');dot.type='button';dot.className='mpr__dot';dot.setAttribute('aria-label',dots.dataset.label+' '+(i+1));dot.addEventListener('click',()=>go(i),opts);dots.append(dot)}}controls.hidden=count<=1;update()};
  prev?.addEventListener('click',()=>go((this.motionTarget??active)-1),opts);next?.addEventListener('click',()=>go((this.motionTarget??active)+1),opts);track.addEventListener('scroll',update,{...opts,passive:true});track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();go((this.motionTarget??active)+(e.key==='ArrowRight'?1:-1))}},opts);
  this.addEventListener('pointerenter',()=>{if(!terra||hover.matches)paused=true},opts);this.addEventListener('pointerleave',()=>paused=false,opts);this.addEventListener('touchstart',()=>paused=true,{...opts,passive:true});this.addEventListener('touchend',()=>paused=false,{...opts,passive:true});this.addEventListener('touchcancel',()=>paused=false,{...opts,passive:true});
  this.resize=new ResizeObserver(resize);this.resize.observe(track);this.observer=new IntersectionObserver(entries=>inView=entries[0].isIntersecting);this.observer.observe(this);
  if(this.dataset.autoplay==='true')this.timer=setInterval(()=>{if(!paused&&inView&&!document.hidden&&!focusBlocks()&&!motion.matches)go((active+1)%count)},Number(this.dataset.interval)||5000);
  resize();
 }
 disconnectedCallback(){this.cancelMotion?.();this.controller?.abort();this.resize?.disconnect();this.observer?.disconnect();clearInterval(this.timer)}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mercadean-product-shipping"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('mercadean-shipping'))customElements.define('mercadean-shipping',class extends HTMLElement{
 connectedCallback(){
  this.refresh();this.timer=setInterval(()=>this.refresh(),60000);
 }
 disconnectedCallback(){clearInterval(this.timer)}
 refresh(){
  const parts=new Intl.DateTimeFormat('en-CA',{timeZone:'America/Bogota',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
  const part=t=>parts.find(p=>p.type===t).value;
  let base=new Date(Date.UTC(Number(part('year')),Number(part('month'))-1,Number(part('day')),12));
  const fixed=this.dataset.base;
  if(/^\d{4}-\d{2}-\d{2}$/.test(fixed||'')){const candidate=new Date(fixed+'T12:00:00Z');if(!isNaN(candidate)&&candidate.toISOString().slice(0,10)===fixed)base=candidate}
  const validDay=(d,mode)=>mode==='weekdays'?d.getUTCDay()!==0&&d.getUTCDay()!==6:mode==='no_sunday'?d.getUTCDay()!==0:true;
  const roll=(d,mode)=>{while(!validDay(d,mode))d.setUTCDate(d.getUTCDate()+1);return d};
  const add=(n,mode=this.dataset.mode)=>{let d=new Date(base),i=0;while(i<n){d.setUTCDate(d.getUTCDate()+1);if(!validDay(d,mode))continue;i++}return roll(d,mode)};
  const fmt=d=>d.getUTCDate()+' '+['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'][d.getUTCMonth()];
  const dm=Math.max(0,Number(this.dataset.dispatchMin)),dx=Math.max(dm,Number(this.dataset.dispatchMax)),em=Math.max(dm,Number(this.dataset.deliveryMin)),ex=Math.max(em,dx,Number(this.dataset.deliveryMax));
  const dispatchMin=add(dm),dispatchMax=add(dx);
  const deliveryMode=this.dataset.deliveryMode||'calendar';
  const deliveryDate=(n,dispatch)=>{let d=add(n,deliveryMode);if(d<dispatch)d=new Date(dispatch);return this.dataset.rollWeekends==='false'?d:roll(d,'weekdays')};
  const deliveryMin=deliveryDate(em,dispatchMin),deliveryMax=deliveryDate(ex,dispatchMax);
  const range=(a,b)=>a.getTime()===b.getTime()?fmt(a):fmt(a)+' – '+fmt(b);
  const values={order:fmt(base),dispatch:range(dispatchMin,dispatchMax),delivery:range(deliveryMin,deliveryMax),'delivery-min':fmt(deliveryMin),'delivery-max':fmt(deliveryMax)};
  this.querySelectorAll('[data-date]').forEach(e=>e.textContent=values[e.dataset.date]||'');
 }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mercadean-product-videos"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('mercadean-videos'))customElements.define('mercadean-videos',class extends HTMLElement{
 connectedCallback(){
  this.controller?.abort();this.resize?.disconnect();
  this.controller=new AbortController();const opts={signal:this.controller.signal};
  const track=this.querySelector('.mpv__track'),cards=[...this.querySelectorAll('.mpv__card')],videos=[...this.querySelectorAll('video')],dots=this.querySelector('.mpv__dots'),controls=this.querySelector('.mpv__controls'),pauseButton=this.querySelector('[data-pause]'),status=this.querySelector('.mpv__status');
  if(!track||!cards.length)return;
  const reduce=matchMedia('(prefers-reduced-motion: reduce)'),manual=new Set(),controlled=new Set();
  let paused=false,positions=[],active=0,target=null;
  const lazy=this.dataset.lazyVideo==='true',userStarted=new Set();let near=!lazy,inViewport=!lazy;
  const hydrate=v=>{if(!v||v.dataset.hydrated==='true')return;v.querySelectorAll('source[data-src]').forEach(s=>{s.src=s.dataset.src});v.dataset.hydrated='true';v.preload='metadata';v.load()};
  const currentVideo=()=>cards[active]?.querySelector('video');
  const pauseVideo=v=>{if(!v.paused){controlled.add(v);v.pause()}};
  const canPlay=v=>v===currentVideo()&&inViewport&&!document.hidden&&!paused&&(!reduce.matches||(lazy&&userStarted.has(v)))&&(!lazy||!navigator.connection?.saveData||userStarted.has(v))&&this.dataset.auto==='true'&&!manual.has(v);
  const sync=()=>{if(lazy&&near&&!navigator.connection?.saveData)hydrate(currentVideo());videos.forEach(v=>{if(!canPlay(v))pauseVideo(v);else if(v.paused){if(lazy)hydrate(v);v.play().catch(()=>{})}})};
  const reflect=()=>{
   this.dataset.activeVideo=String(active+1);
   cards.forEach((card,i)=>{card.dataset.active=String(i===active);if(i===active)card.setAttribute('aria-current','true');else card.removeAttribute('aria-current')});
   dots.querySelectorAll('button').forEach((dot,i)=>dot.setAttribute('aria-current',String(i===active)));
   sync();
  };
  videos.forEach(v=>{
   v.preload=lazy?'none':'auto';v.muted=true;v.playsInline=true;
   if(!lazy&&v.networkState===0)v.load();
   if(lazy)v.addEventListener('pointerdown',()=>{userStarted.add(v);hydrate(v)},opts);
   v.addEventListener('loadedmetadata',()=>{if(v!==currentVideo()&&!v.poster&&v.currentTime===0&&v.duration>0)v.currentTime=Math.min(.001,v.duration);sync()},opts);
   v.addEventListener('loadeddata',sync,opts);v.addEventListener('canplay',sync,opts);
   v.addEventListener('pause',()=>{if(controlled.has(v))controlled.delete(v);else manual.add(v)},opts);
   v.addEventListener('play',()=>{manual.delete(v);if(!canPlay(v))pauseVideo(v)},opts);
   v.addEventListener('volumechange',()=>{if(!v.muted)videos.forEach(other=>{if(other!==v)other.muted=true})},opts);
  });
  if(lazy&&'IntersectionObserver' in window){this.nearObserver=new IntersectionObserver(entries=>{near=entries.some(e=>e.isIntersecting);sync()},{rootMargin:'180px 0px'});this.nearObserver.observe(this);this.visibleObserver=new IntersectionObserver(entries=>{inViewport=entries.some(e=>e.isIntersecting&&e.intersectionRatio>=.15);sync()},{threshold:[0,.15]});this.visibleObserver.observe(this)}else if(lazy){near=true;inViewport=true}
  document.addEventListener('visibilitychange',sync,opts);reduce.addEventListener('change',sync,opts);
  document.addEventListener('pointerdown',sync,opts);document.addEventListener('keydown',sync,opts);
  pauseButton?.addEventListener('click',()=>{paused=!paused;pauseButton.setAttribute('aria-pressed',String(paused));pauseButton.textContent=paused?pauseButton.dataset.start:pauseButton.dataset.stop;if(!paused)manual.clear();sync()},opts);
  const update=()=>{
   if(target!==null)active=target;
   else{
    let best=active,distance=Math.abs((positions[active]||0)-track.scrollLeft);
    positions.forEach((left,i)=>{const next=Math.abs(left-track.scrollLeft);if(next<distance-2){best=i;distance=next}});
    active=best;
   }
   reflect();
  };
  const go=index=>{
   if(!positions.length)return;
   const i=(index+positions.length)%positions.length;this.cancelMotion?.();target=i;active=i;reflect();
   const done=()=>{target=null;update();status.textContent=dots.dataset.label+' '+(i+1)+' / '+positions.length};
   if(window.MercadeanMotion)this.cancelMotion=window.MercadeanMotion.scroll(track,positions[i],this.dataset.smooth==='true',done);
   else{track.scrollTo({left:positions[i],behavior:this.dataset.smooth==='true'&&!reduce.matches?'smooth':'instant'});done()}
  };
  const resize=()=>{
   this.cancelMotion?.();target=null;const max=Math.max(0,track.scrollWidth-track.clientWidth);
   const trackRect=track.getBoundingClientRect();
   positions=cards.map(card=>{const rect=card.getBoundingClientRect();return Math.max(0,Math.min(max,track.scrollLeft+rect.left-trackRect.left+(rect.width-track.clientWidth)/2))});
   active=Math.min(active,cards.length-1);
   dots.replaceChildren();positions.forEach((left,i)=>{const dot=document.createElement('button');dot.type='button';dot.className='mpv__dot';dot.setAttribute('aria-label',dots.dataset.label+' '+(i+1));dot.addEventListener('click',()=>go(i),opts);dots.append(dot)});
   controls.hidden=positions.length<2;track.scrollTo({left:positions[active],behavior:'instant'});update();
  };
  this.querySelector('[data-prev]').addEventListener('click',()=>go((target??active)-1),opts);this.querySelector('[data-next]').addEventListener('click',()=>go((target??active)+1),opts);
  track.addEventListener('scroll',update,{...opts,passive:true});
  track.addEventListener('keydown',e=>{if(e.target!==track)return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();go((target??active)+(e.key==='ArrowRight'?1:-1))}else if(e.key==='Home'||e.key==='End'){e.preventDefault();go(e.key==='Home'?0:positions.length-1)}},opts);
  this.addEventListener('shopify:block:select',e=>{const card=e.target.closest('.mpv__card');if(card)go(cards.indexOf(card))},opts);
  this.resize=new ResizeObserver(resize);this.resize.observe(track);resize();
 }
 disconnectedCallback(){this.nearObserver?.disconnect();this.visibleObserver?.disconnect();this.cancelMotion?.();this.controller?.abort();this.resize?.disconnect();this.querySelectorAll('video').forEach(v=>v.pause())}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-collection-products-1"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('ms-collection-products-one')) {
 customElements.define('ms-collection-products-one', class extends HTMLElement {
  connectedCallback() {
   this.controller?.abort();this.resize?.disconnect();this.observer?.disconnect();this.finishAll?.();
   this.controller=new AbortController();const options={signal:this.controller.signal};
   const reduced=matchMedia('(prefers-reduced-motion: reduce)');const hover=matchMedia('(hover:hover) and (pointer:fine)');const narrow=matchMedia('(max-width:989px)');
   const rows=[...this.querySelectorAll('.cp1__row')];this.cancels=new Map();this.animations=[];
   const perPage=()=>{const css=getComputedStyle(this);return parseInt(css.getPropertyValue(matchMedia('(max-width:749px)').matches?'--cp1-columns-mobile':'--cp1-columns-tablet'))||2;};
   const isCarousel=()=>narrow.matches&&this.dataset.layout==='carousel';
   const step=row=>{const first=row.firstElementChild,second=first?.nextElementSibling;return second?second.offsetLeft-first.offsetLeft:first?.getBoundingClientRect().width||1;};
   const current=row=>Math.round(row.scrollLeft/(step(row)*perPage()||1));
   const update=row=>{const controls=row.nextElementSibling;const total=Math.ceil(row.children.length/perPage());const page=Math.max(0,Math.min(total-1,current(row)));controls.hidden=!isCarousel()||total<=1||!controls.querySelector('button,.cp1__page-status');row.tabIndex=isCarousel()?0:-1;controls.querySelector('[data-prev]')?.toggleAttribute('disabled',page<=0);controls.querySelector('[data-next]')?.toggleAttribute('disabled',page>=total-1);const status=controls.querySelector('.cp1__page-status');if(status)status.textContent=(page+1)+' / '+total;};
   const go=(row,page)=>{this.finishRow?.(row);this.cancels.get(row)?.();const total=Math.ceil(row.children.length/perPage());const target=Math.max(0,Math.min(total-1,page));const left=Math.min(row.scrollWidth-row.clientWidth,target*perPage()*step(row));row.dataset.target=String(target);const done=()=>{delete row.dataset.target;update(row);};
    const snap=row.style.scrollSnapType,start=row.scrollLeft;let frame=0,ended=false;const stop=()=>{if(ended)return;ended=true;cancelAnimationFrame(frame);row.style.scrollSnapType=snap;done();};this.cancels.set(row,stop);row.style.scrollSnapType='none';
    if(reduced.matches){row.scrollLeft=left;stop();return;}
    const began=performance.now(),duration=Number(this.dataset.navDuration)||400;const tick=now=>{const p=Math.min(1,(now-began)/duration);row.scrollLeft=start+(left-start)*(1-Math.pow(1-p,3));if(p<1)frame=requestAnimationFrame(tick);else stop();};frame=requestAnimationFrame(tick);
   };
   rows.forEach(row=>{row.nextElementSibling.querySelector('[data-prev]')?.addEventListener('click',()=>go(row,Number(row.dataset.target??current(row))-1),options);row.nextElementSibling.querySelector('[data-next]')?.addEventListener('click',()=>go(row,Number(row.dataset.target??current(row))+1),options);
    row.addEventListener('scroll',()=>{if(row.scrollLeft>0)this.finishRow?.(row);update(row);},{...options,passive:true});row.addEventListener('scrollend',()=>{delete row.dataset.target;update(row);},options);
    const interrupt=()=>{this.finishRow?.(row);this.cancels.get(row)?.();delete row.dataset.target;};row.addEventListener('pointerdown',interrupt,{...options,passive:true});row.addEventListener('wheel',interrupt,{...options,passive:true});
    row.addEventListener('keydown',e=>{if(!isCarousel()||e.target!==row)return;let page;if(e.key==='ArrowRight')page=current(row)+1;if(e.key==='ArrowLeft')page=current(row)-1;if(e.key==='Home')page=0;if(e.key==='End')page=Math.ceil(row.children.length/perPage())-1;if(page===undefined)return;e.preventDefault();go(row,page);},options);update(row);
   });
   let previousWidth=this.clientWidth;this.resize=new ResizeObserver(()=>{if(previousWidth===this.clientWidth)return;previousWidth=this.clientWidth;this.finishAll?.();rows.forEach(row=>{this.cancels.get(row)?.();row.scrollTo({left:0,behavior:'instant'});delete row.dataset.target;update(row);});});this.resize.observe(this);
   narrow.addEventListener('change',()=>rows.forEach(update),options);
   this.querySelectorAll('.cp1__media--pair').forEach(media=>{const card=media.closest('.cp1__card');const primary=media.querySelector('.cp1__image--primary'),secondary=media.querySelector('.cp1__image--secondary');const show=on=>{if(this.dataset.swap!=='true')return;media.classList.toggle('is-secondary',on);primary?.setAttribute('aria-hidden',String(on));secondary?.setAttribute('aria-hidden',String(!on));};
    card.addEventListener('pointerenter',e=>{if(hover.matches&&e.pointerType==='mouse')show(true);},options);card.addEventListener('pointerleave',e=>{if(e.pointerType==='mouse'&&!card.contains(document.activeElement))show(false);},options);card.addEventListener('focusin',()=>show(true),options);card.addEventListener('focusout',e=>{if(!card.contains(e.relatedTarget))show(false);},options);
    let down;media.addEventListener('pointerdown',e=>{if(e.pointerType!=='mouse')down={x:e.clientX,y:e.clientY};},options);media.addEventListener('pointerup',e=>{if(down&&Math.hypot(e.clientX-down.x,e.clientY-down.y)<8)show(true);down=null;},options);media.addEventListener('pointercancel',()=>{down=null;show(false);},options);
   });
   const pending=new Set(),running=new Map(),rowCards=new Map();
   const finish=target=>{pending.delete(target);target.dataset.cp1Motion='shown';const a=running.get(target);running.delete(target);a?.cancel();};
   this.finishRow=row=>{this.observer?.unobserve(row);(rowCards.get(row)||[]).forEach(finish);};
   this.finishAll=()=>{this.observer?.disconnect();[...pending,...running.keys()].forEach(finish);};
   if(this.dataset.reveal==='true'&&!reduced.matches&&!window.Shopify?.designMode&&'IntersectionObserver'in window&&Element.prototype.animate){
    const css=getComputedStyle(this),duration=Math.min(1000,Math.max(250,parseFloat(css.getPropertyValue('--cp1-reveal-duration'))||600));
    const d=parseFloat(css.getPropertyValue('--cp1-reveal-distance')),distance=Number.isFinite(d)?Math.min(40,Math.max(0,d)):24;
    const stagger=Math.min(100,Math.max(0,parseFloat(css.getPropertyValue('--cp1-reveal-stagger'))||0));
    const prepare=target=>{target.dataset.cp1Motion='waiting';pending.add(target);};
    const reveal=(target,delay)=>{
     if(!pending.has(target))return;
     if(reduced.matches){finish(target);return;}
     pending.delete(target);target.dataset.cp1Motion='running';
     try{const a=target.animate([{opacity:0,translate:'0 '+(matchMedia('(max-width:749px)').matches?Math.min(distance,18):distance)+'px'},{opacity:1,translate:'0 0'}],{duration,delay,easing:'cubic-bezier(.22,.61,.36,1)',fill:'both'});running.set(target,a);a.finished.then(()=>{if(running.get(target)===a)finish(target);}).catch(()=>{});}catch{finish(target);}
    };
    this.observer=new IntersectionObserver(entries=>{
     const visible=entries.filter(e=>e.isIntersecting).sort((a,b)=>a.target.compareDocumentPosition(b.target)&Node.DOCUMENT_POSITION_FOLLOWING?-1:1);
     let order=0;
     visible.forEach(({target})=>{this.observer.unobserve(target);const cards=rowCards.get(target);if(cards)cards.forEach(card=>{if(pending.has(card))reveal(card,Math.min(order++*stagger,280));});else reveal(target,Math.min(order++*stagger,280));});
    },{threshold:0,rootMargin:'0px 0px -28px 0px'});
    this.querySelectorAll('.cp1__heading,.cp1__subtitle,.cp1__hint').forEach(target=>{if(target.getBoundingClientRect().bottom<0||target.offsetParent===null)return;prepare(target);this.observer.observe(target);});
    rows.forEach(row=>{
     const cards=[...row.children],box=row.getBoundingClientRect();rowCards.set(row,cards);
     if(box.bottom<0)return;
     cards.forEach(card=>{const c=card.getBoundingClientRect();if(c.right>box.left+1&&c.left<box.right-1)prepare(card);});
     this.observer.observe(row);
    });
    this.addEventListener('focusin',e=>{const row=e.target.closest('.cp1__row');if(row)this.finishRow(row);else{const target=e.target.closest('[data-cp1-motion]');if(target)finish(target);}},options);
    window.addEventListener('beforeprint',()=>this.finishAll(),options);
    window.addEventListener('pageshow',e=>{if(e.persisted)this.finishAll();},options);
   }
   reduced.addEventListener('change',()=>{this.finishAll();this.cancels.forEach(cancel=>cancel?.());},options);

   if(window.Shopify?.designMode)document.addEventListener('shopify:block:select',event=>{if(!this.contains(event.target)||!isCarousel())return;const cell=event.target.closest('.cp1__cell'),row=cell?.closest('.cp1__row');if(row)go(row,Math.floor([...row.children].indexOf(cell)/perPage()));},options);
  }
  disconnectedCallback(){this.finishAll?.();this.controller?.abort();this.resize?.disconnect();this.observer?.disconnect();this.cancels?.forEach(cancel=>cancel?.());this.animations?.forEach(animation=>animation.cancel());}
 });
}



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-product-offers-2"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('ms-offers-two'))customElements.define('ms-offers-two',class extends HTMLElement{
 connectedCallback(){
  this.controller?.abort();this.controller=new AbortController();const opts={signal:this.controller.signal},cards=[...this.querySelectorAll('.mpo2__card')],status=this.querySelector('.mpo2__selection');

  const motion=matchMedia('(prefers-reduced-motion: reduce)');let ready=false;
  this.detailAnimations=new Map();
  const showDetails=(details,show)=>{
   const previous=this.detailAnimations.get(details);
   if(!previous&&details.hidden===!show)return;
   const from=details.hidden?0:details.getBoundingClientRect().height;
   const opacity=details.hidden?0:Number(getComputedStyle(details).opacity);
   previous?.cancel();this.detailAnimations.delete(details);
   if(!ready||this.dataset.terraOffers!=='true'||motion.matches||!details.animate){details.hidden=!show;details.inert=!show;return}
   details.hidden=false;details.inert=!show;
   const full=details.getBoundingClientRect().height;
   const animation=details.animate([
    {height:from+'px',opacity,paddingBottom:from===0?'0px':getComputedStyle(details).paddingBottom,overflow:'hidden'},
    {height:(show?full:0)+'px',opacity:show?1:0,paddingBottom:show?getComputedStyle(details).paddingBottom:'0px',overflow:'hidden'}
   ],{duration:show?420:320,easing:'cubic-bezier(.22,1,.36,1)',fill:'both'});
   this.detailAnimations.set(details,animation);
   animation.onfinish=()=>{if(this.detailAnimations.get(details)!==animation)return;details.hidden=!show;this.detailAnimations.delete(details);animation.cancel()};
  };
  const select=(card,focus=false,syncNative=true)=>{cards.forEach(c=>{const active=c===card;c.setAttribute('aria-checked',String(active));c.tabIndex=active?0:-1;const details=c.parentElement.querySelector('.mpo2__details');if(details)showDetails(details,active)});if(focus)card.focus();this.selectedOffer={blockId:card.dataset.offer,variantId:card.dataset.variant,quantity:Number(card.dataset.quantity),price:card.dataset.price};if(status)status.textContent=this.dataset.label+' '+card.dataset.name+' · '+card.dataset.quantity+' '+this.dataset.unit+' · '+card.dataset.price;this.dispatchEvent(new CustomEvent('mercadean:offer-change',{bubbles:true,detail:this.selectedOffer}));if((this.dataset.terraOffers==='true'||this.dataset.oftalmielOffers==='true')&&syncNative&&this.dataset.codSync==='true'){pending=card;queue()}};
  cards.forEach((card,i)=>{card.addEventListener('click',()=>select(card),opts);card.addEventListener('keydown',e=>{let next=i;if(e.key==='ArrowRight'||e.key==='ArrowDown')next=(i+1)%cards.length;else if(e.key==='ArrowLeft'||e.key==='ArrowUp')next=(i-1+cards.length)%cards.length;else if(e.key==='Home')next=0;else if(e.key==='End')next=cards.length-1;else return;e.preventDefault();select(cards[next],true)},opts)});

  const norm=s=>String(s||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim().toLowerCase(),amount=s=>String(s||'').replace(/[^0-9]/g,'');
  let pending=null,frame=0;
  const nativeCards=()=>{const modal=document.querySelector('#_rsi-cod-form-modal');return modal&&modal.getClientRects().length?[...modal.querySelectorAll('._rsi-quantity-offers-offer-container')]:[]};
  const matches=(outer,native)=>norm(native.querySelector('._rsi-quantity-offers-title')?.textContent)===norm(outer.dataset.name)&&amount(native.querySelector('._rsi-quantity-offers-new-price')?.textContent)===amount(outer.dataset.price);
  const reconcile=()=>{frame=0;const native=nativeCards();if(!native.length)return;
  if(this.dataset.terraOffers==='true'){
   const complete=cards.length===3&&cards.every(c=>native.some(n=>matches(c,n)));
   if(complete){const modal=document.getElementById('_rsi-cod-form-modal');if(!modal.classList.contains('ms-terra-offers'))modal.classList.add('ms-terra-offers');
    native.forEach(n=>{const outer=cards.find(c=>matches(c,n));if(!outer)return;const source=outer.querySelector('img')?.currentSrc||outer.querySelector('img')?.src;const body=n.querySelector('._rsi-quantity-offers-offer');if(!source||!body)return;let image=body.querySelector('img');if(!image){image=document.createElement('img');image.alt='';body.prepend(image)}if(image.src!==source)image.src=source;if(!image.classList.contains('ms-terra-offer-image'))image.classList.add('ms-terra-offer-image');image.loading='lazy';});
   }
  }
  if(pending){const target=native.find(n=>matches(pending,n));if(!target)return;if(!target.classList.contains('_rsi-quantity-offers-selected'))target.querySelector('._rsi-quantity-offers-offer')?.click();return;}const current=native.find(n=>n.classList.contains('_rsi-quantity-offers-selected'));const outer=current&&cards.find(c=>matches(c,current));if(outer&&outer.getAttribute('aria-checked')!=='true')select(outer,false,false);};
  const queue=()=>{if(!frame)frame=requestAnimationFrame(reconcile)};
  if(this.dataset.codSync==='true'){document.addEventListener('click',e=>{if(e.isTrusted&&e.target.closest('._rsi-quantity-offers-offer-container')){pending=null;queue()}if(e.target.closest('._rsi-buy-now-button')){pending=cards.find(c=>c.getAttribute('aria-checked')==='true')||null;queue()}}, {...opts,capture:true});this.nativeObserver=new MutationObserver(queue);this.nativeObserver.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['class','style']});}
  this.stopSync=()=>{this.nativeObserver?.disconnect();cancelAnimationFrame(frame)};
  this.addEventListener('shopify:block:select',e=>{const card=e.target.closest('.mpo2__item')?.querySelector('.mpo2__card');if(card)select(card,false,false)},opts);
  if(cards.length)select(cards[Math.min(cards.length-1,Math.max(0,Number(this.dataset.default)-1))]);ready=true;
 }
 disconnectedCallback(){this.controller?.abort();this.stopSync?.();this.detailAnimations?.forEach(a=>a.cancel());this.detailAnimations?.clear()}
});


  } catch(e) { console.error(e); }
})();
})();
